<!-- <div class="main">

    <div class="header d-flex just-space">
        <span class="h5-b">Employee Details</span>
        <button class="transparent-button pointer-cursor" (click)=" closeModal()"><span class="icon-ic-navigation-cancel-24 close-icon"></span></button>
    </div>

   

    <div class="table-container-view">
        <table class="table-container InPremise-table">
            <div class="table-scroll">
              <thead>
                <tr>
                  <th *ngFor="let col of employee_detail_column">{{ col }}</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of temp_employee_details_list">
                  <td style="min-width: 44px;" *ngIf="item.noShow==true" [ngClass]="{'no-show-bg':item.noShow==true}"><img src="assets/icons/NoShowWithBg.svg" alt=""></td>
                  <td style="min-width: 44px;" *ngIf="item.adhoc==true && item.noShow==false"  [ngClass]="{'adhoc-bg':item.adhoc==true && item.noShow==false}"><img src="assets/icons/Adhoc.svg" alt=""></td>
                  <td style="min-width: 44px;" *ngIf="item.adhoc==false && item.noShow==false" [ngClass]="{'planned-bg':item.adhoc==false && item.noShow==false}"></td>

                  <td style="min-width: 94px;">{{item.Id}}</td>
                  <td misToolTip  [text]="item?.name" [position]="'bottom'" style="max-width: 106px;" class="truncate">{{item?.name}}</td>
                  <td style="max-width: 78px;">{{item.gender}}</td>
                  <td misToolTip  [text]="item.location" [position]="'bottom'" style="max-width: 208px;" class="truncate">{{item.location}}</td>
                  <td misToolTip  [text]="item.landmark" [position]="'bottom'" style="max-width: 174px;" class="truncate">{{item.landmark}}</td>
                  <td style="max-width: 78px;">{{item.signIn}}</td>
                  <td style="max-width: 78px;">{{item.signOut}}</td>
                  <td style="max-width: 92px;">{{item.reportTime || '--'}}</td>
                  <td style="max-width: 92px;">{{item.distance || '--'}}</td>
                  <td style="max-width: 104px;">{{item.phone || '--'  }}</td>
                </tr>
              </tbody>
            </div>
          </table>
    </div>

    <div class="information d-flex flex-dir-col">
        <div class="d-flex gap-24">
            <div class="d-flex gap-4"><img src="assets/icons/Adhoc.svg" alt=""><span class="h7">AdHoc Employee</span></div>
            <div class="d-flex gap-4"><img src="assets/icons/NoShowWithBg.svg" alt=""><span class="h7">No Show Employee</span></div>
            <div class="d-flex gap-4"><img src="assets/icons/PlannedSignin.svg" alt=""><span class="h7">Planned Sign in</span></div>
        </div>

        <div class="d-flex flex-dir-col">
            <span class="h7-b">* Time when driver reported at employee's pickup place.This is updated on trip completion.</span>
            <span class="h7-b">**Distance traveled by employee from the start point.</span>
        </div>

    </div>



  
</div>
 -->


<div class="main d-flex just-space flex-dir-col">
  <div>
    <div class="header d-flex just-space">
      <span class="h5-b">Planned Employees : {{plannedSignIn+noShows}}</span>
      <button class="transparent-button pointer-cursor" (click)=" closeModal()"><img
          src="{{imgSrc}}assets/icons/navigation-cancel.svg" /></button>
    </div>

    <div class="d-flex gap-15 flex-dir-row color-grey trip-detail">
      <span>Shuttle Route Id:{{tripDetails['shuttleRouteId']}}</span>
      <span>Trip Id:{{tripDetails['tripId']}}</span>
      <span>Shift:{{shiftTime}}&nbsp;{{tripDetails['direction']}}</span>
      <!-- <span>Office: {{officeStops.length>1?'-- (Please refer office column)':officeStops[0]['address']}}</span> -->
    </div>

    <div class="selection-buttons d-flex">
      <div class="d-flex gap-8">
      <div (click)="toggleSelectedButtons('planned')" class="btn d-flex align-center gap-8 pointer-cursor"
        [ngClass]="{'selected-btn-plan':selectedPlannned==true,'unselected-btn':selectedPlannned==false,'disable':plannedSignIn===0}">
        <span *ngIf="selectedPlannned" class="icon-ic-ui-check-24"></span>
        <span class="h7">Planned Sign In: {{plannedSignIn}}</span>
      </div>
      <div (click)="toggleSelectedButtons('noShow')" class="btn d-flex align-center gap-8 pointer-cursor"
        [ngClass]="{'selected-btn-noshow':selectedNoShow==true,'unselected-btn':selectedNoShow==false,'disable':noShows===0}">
        <span *ngIf="selectedNoShow" class="icon-ic-ui-check-24"></span>
        <span class="h7">No show: {{noShows}}</span>
      </div>
      <div (click)="toggleSelectedButtons('adhoc')" class="btn d-flex align-center gap-8 pointer-cursor"
        [ngClass]="{'selected-btn-adhoc':selectedAdHoc==true,'unselected-btn':selectedAdHoc==false,'disable':adhocs===0}">
        <span *ngIf="selectedAdHoc" class="icon-ic-ui-check-24"></span>
        <span class="h7">AdHoc: {{adhocs}}</span>
      </div>
      <div (click)="toggleSelectedButtons('notBoarded')" class="btn d-flex align-center gap-8 pointer-cursor"
        [ngClass]="{'selected-btn-not-boarded':selectedNotBoarded==true,'unselected-btn':selectedNotBoarded==false,'disable':notBoarded===0}">
        <span *ngIf="selectedNotBoarded" class="icon-ic-ui-check-24"></span>
        <span class="h7">Not Boarded: {{notBoarded}}</span>
      </div>
      </div>
      <div class="a-link" (click)="openModal()">
        View Unknown RFID Tag Swipes
      </div>
    </div>
    <div class="table-container">
      <table id="myTable" mat-table [dataSource]="temp_employee_details_list" multiTemplateDataRows>
        <ng-container matColumnDef=" ">
          <th mat-header-cell *matHeaderCellDef> Status </th>

          <td class="h7 color-text" mat-cell *matCellDef="let element">
            <div class="h7-b" id="status-{{element.Id}}">{{ getEmployeeStatus(element.Id) }}</div>
            <div *ngIf="element.noShow && element.noShowMarkedBy" class="marked-by-text">Marked by - {{element.noShowMarkedBy}}</div>

            <!-- <span id="status" *ngIf="getEmployeeStatus(element.Id)==='NO-SHOW'" >{{ getEmployeeStatus(element.Id) }}</span>
            <span id="status" *ngIf="getEmployeeStatus(element.Id)==='AD-HOC'" >{{ getEmployeeStatus(element.Id) }}</span>
            <span id="status" *ngIf="getEmployeeStatus(element.Id)==='NOT-BOARDED'" >{{ getEmployeeStatus(element.Id) }}</span> -->

          </td>

        </ng-container>
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> ID </th>
          <td class="h7 color-text" mat-cell *matCellDef="let element"> {{element.Id}} </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td class="h7" mat-cell *matCellDef="let element"> {{element?.name}} </td>
        </ng-container>
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef> Phone </th>
          <td class="h7 color-text" mat-cell *matCellDef="let element;let i = dataIndex;"> {{
            getEmployeeHiddenText(element,'phone')}} </td>
        </ng-container>


        <ng-container matColumnDef="gender">
          <th mat-header-cell *matHeaderCellDef> Gender </th>
          <td class="h7 color-text" mat-cell *matCellDef="let element">

            <img misToolTip [text]="'Male'" [position]="'bottom'" *ngIf="element.gender==='Male'"
              src="{{imgSrc}}assets/icons/male-emp.svg" />
            <img misToolTip [text]="'Female'" [position]="'bottom'" *ngIf="element.gender==='Female'"
              src="{{imgSrc}}assets/icons/female-emp.svg" />
          </td>
        </ng-container>

        <ng-container matColumnDef="pickup">
          <th mat-header-cell *matHeaderCellDef> Pickup Location </th>
          <td misToolTip style="padding-right: 15px;" [text]="getEmployeeHiddenText(element,'pickup')" class="h7 color-text text-wrap" mat-cell
            *matCellDef="let element">{{
             getEmployeeHiddenText(element,'pickup')}}
            </td>
        </ng-container>


        <ng-container matColumnDef="report">
          <th mat-header-cell *matHeaderCellDef> Report Time<sup>*</sup> </th>
          <td class="h7 color-text" mat-cell *matCellDef="let element"> {{element.reportTime || '--'}} </td>
        </ng-container>

        <ng-container matColumnDef="office">
          <th mat-header-cell *matHeaderCellDef> Office<sup>*</sup> </th>
          <td class="h7 color-text" mat-cell *matCellDef="let element"><span
              *ngFor="let stop of officeStops;let i=index">{{stop.address}} <span *ngIf="i!==officeStops.length-1">
                -</span></span> </td>
        </ng-container>

        <ng-container matColumnDef="planned">
          <th mat-header-cell *matHeaderCellDef> Planned Sign In </th>
          <td class="h7 color-text" mat-cell *matCellDef="let element">{{element.plannedPickupTime}} </td>
        </ng-container>
        <ng-container matColumnDef="signIn">
          <th mat-header-cell *matHeaderCellDef>Sign In/Sign Out </th>
          <td class="h7 color-text" mat-cell *matCellDef="let element">
            <ng-container *ngIf="!element.noShow">{{element.signIn}} / {{element.signedOff ? element.signOut :" --"}}</ng-container>
            <ng-container *ngIf="element.noShow">
              <div class="marked-by-text-time">No show marked at</div>
              <div>{{element.noShowTimeStamp ? formatNoShowTimestamp(element.noShowTimeStamp) : " --"}}</div>
            </ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="distanceDriverDevice">
          <th mat-header-cell *matHeaderCellDef>
            <div style="line-height: 1.2;">
              Distance<br>
              <span style="font-size: 0.85em;">(Driver Device)</span>
            </div>
          </th>
          <td class="h7 color-text" mat-cell *matCellDef="let element">{{element.distance | distance:2 }} </td>
        </ng-container>


          <ng-container matColumnDef="proximityHit">
            <th mat-header-cell *matHeaderCellDef> Proximity Hit IN/OUT </th>
            <td class="h7 color-text" mat-cell *matCellDef="let element">
              {{element.proximityIn || '--'}} / {{element.proximityOut || '--'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="cabInOut">
            <th mat-header-cell *matHeaderCellDef> Cab IN/OUT </th>
            <td class="h7 color-text" mat-cell *matCellDef="let element">
              {{element.cabInTime || '--'}} / {{element.cabOutTime || '--'}}
            </td>
          </ng-container>

        <ng-container matColumnDef="distanceFixedDevice">
          <th mat-header-cell *matHeaderCellDef>
            <div style="line-height: 1.2;">
              Distance<br>
              <span style="font-size: 0.85em;">(Fixed Device)</span>
            </div>
          </th>
          <td class="h7 color-text" mat-cell *matCellDef="let element">{{element.fdTravelledDistance ? (element.fdTravelledDistance | distance:2) : '--' }} </td>
        </ng-container>


        <!-- <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element">
          <a mat-button href="javascript:void()" (click)="element.isExpanded = !element.isExpanded">View
            Subjects</a>
        </td>
      </ng-container> -->


        <!-- Template for details row -->
        <!-- <ng-container matColumnDef="expandedDetail">
        <th mat-header-cell *matHeaderCellDef> Phone </th>
        <td mat-cell *matCellDef="let element" [attr.colspan]="temp_employee_details_list.length">
    
          <div class="row student-element-detail" [@detailExpand]="isTableExpanded ? 'expanded' : 'collapsed'">
            {{element.phone}}
          </div>
    
        </td>
      </ng-container> -->


        <tr mat-header-row *matHeaderRowDef="employee_detail_column;sticky: true"></tr>
        <tr mat-row *matRowDef="let element; columns: employee_detail_column;" class="student-element-row"
          [class.student-expanded-row]="isTableExpanded"></tr>

        <!-- Extra row to show detail content column -->
        <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="student-detail-row"></tr> -->

      </table>
      <div id="Line" class="line" [ngClass]="{'exp-line':isTableExpanded}">
        <img misToolTip [text]="'Expand'" [position]="'right'" *ngIf="!isTableExpanded"
          src="{{imgSrc}}assets/icons/navigation-expand.svg" (click)="toggleColumns('expand')" />
        <img misToolTip [text]="'Collapse'" [position]="'left'" style="margin-left:-18px;" *ngIf="isTableExpanded"
          src="{{imgSrc}}assets/icons/navigation-collapse.svg" (click)="toggleColumns('collapse')" />
      </div>
    </div>
  </div>




  <div class="d-flex flex-dir-col">
    <span class="h7"><sup>*</sup>Time when driver reported at employee's pickup place.This is updated on trip
      completion.</span>
    <span class="h7"><sup>**</sup>Distance traveled by employee from the start point.</span>
  </div>

</div>